import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LogOutIcon, MenuIcon, UserIcon } from '@/assets/icons';
import { NoAvatarImage } from '@/assets/images';
import { useLogout } from '@/auth/useLogout';
import { useViewerProfile } from '@/auth/useViewerProfile';
import { IconButton, Skeleton } from '@/components';
import {
  Dropdown,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuSimpleItem,
  DropdownMenuTrigger,
} from '@/components/organisms';
import { useSidebar } from '@/components/organisms/Sidebar/sidebar.constants';
import { RoutesEnum } from '@/enums';
import { useAppNavigate } from '@/router/useAppNavigate';

export const HeaderMobile: FC = () => {
  const { t } = useTranslation('components');
  const { displayName, profileImageUrl, isProfileLoading } = useViewerProfile();
  const logout = useLogout();
  const { openMobile, setOpenMobile } = useSidebar();

  const navigate = useAppNavigate();

  const [isOpenDropdownMenu, setIsOpenDropdownMenu] = useState(false);

  const handleTogleMobile = () => {
    setOpenMobile(!openMobile);
  };

  const handleLogout = () => {
    setIsOpenDropdownMenu(false);
    logout();
  };

  const handleNavigateAccountSettings = () => {
    setIsOpenDropdownMenu(false);
    navigate(RoutesEnum.ACCOUNT_SETTINGS);
  };

  return (
    <div className="py-6 px-5 flex md:hidden items-center justify-between bg-custom-warm-grey-25 border-b border-b-custom-warm-grey-200">
      <div>
        <IconButton
          icon={<MenuIcon width={24} height={24} className="text-custom-warm-grey-500" />}
          variant="teritary-bright"
          size="md"
          onClick={handleTogleMobile}
          data-testid="open-sidebar-mobile-button"
        />
      </div>
      <div className="flex items-center gap-2">
        <div>
          <Dropdown open={isOpenDropdownMenu} onOpenChange={setIsOpenDropdownMenu}>
            <DropdownMenuTrigger variant="transparent" asChild>
              <div className="flex items-center gap-2">
                {isProfileLoading ? (
                  <Skeleton
                    className="h-5 w-[120px] rounded-md"
                    data-testid="header-mobile-name-skeleton"
                  />
                ) : (
                  <h6 className="text-body-14-semibold text-custom-warm-grey-950">{displayName}</h6>
                )}
                <img
                  src={profileImageUrl ?? NoAvatarImage}
                  alt="Person"
                  width={32}
                  height={32}
                  className="rounded-full cursor-pointer !p-0"
                />
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-[220px] gap-2">
              <div className="flex items-center px-3 py-2 gap-2.5">
                <span className="text-sm text-custom-warm-grey-700 font-medium">
                  {t('dashboardSidebar.role')}
                </span>
              </div>
              <DropdownMenuSeparator className="my-0" />
              <div className="space-y-[2px]">
                <DropdownMenuSimpleItem
                  className="text-sm text-custom-warm-grey-700"
                  onClick={handleNavigateAccountSettings}
                >
                  <UserIcon className="text-custom-warm-grey-400" />{' '}
                  {t('dashboardSidebar.profileSettings')}
                </DropdownMenuSimpleItem>
                <DropdownMenuSimpleItem
                  onClick={handleLogout}
                  className="text-sm text-custom-warm-grey-700"
                >
                  <LogOutIcon width={20} height={20} className="text-custom-warm-grey-400" />{' '}
                  {t('dashboardSidebar.signOut')}
                </DropdownMenuSimpleItem>
              </div>
            </DropdownMenuContent>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};
